var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBuild(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 18,
    viewBox: "0 0 19 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.8396 14.6763C18.0189 14.7788 18.0958 14.9581 18.0702 15.2143C18.0702 15.4448 17.9677 15.6497 17.7628 15.8291L15.88 17.7118C15.4958 18.0961 15.1115 18.0961 14.7273 17.7118L7.27307 10.2576C6.3509 10.6418 5.36469 10.7315 4.31444 10.5266C3.28981 10.296 2.39325 9.79652 1.62478 9.02805C0.805069 8.20834 0.292753 7.23494 0.0878258 6.10784C-0.117101 4.98075 0.0365941 3.9305 0.548911 2.95709L4.16075 6.49208L6.61987 4.03296L3.08488 0.497972C4.05828 0.0368868 5.10853 -0.104 6.23563 0.0753106C7.36273 0.254622 8.33613 0.75413 9.15584 1.57384C9.92431 2.34231 10.411 3.25168 10.6159 4.30193C10.8465 5.32656 10.7696 6.29996 10.3854 7.22213L17.8396 14.6763Z",
    fill: "#808888"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBuild);
export default __webpack_public_path__ + "static/media/build.4f202b4a6c93a174bea0fc2b081aa65d.svg";
export { ForwardRef as ReactComponent };